import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Departure from './user/Departure';
import Arrival from './user/Arrival';
import AdminPage from "./admin/AdminPage";
import Login from "./admin/Login";
import DebugPage from "./admin/DebugPage";

import { ArrivalProvider } from "./context/Arrival";
import { DepartureProvider } from "./context/Departure";
import { AuthProvider } from "./context/Auth";
import PrivateRoute from "./admin/Private/Private";
import ModeRedirector from "./components/ModeRedirector";

import { Provider } from "react-redux";

import store from "./Redux/StoreConfig/store.js";

// Hook to manage kiosk-mode class on body
function KioskModeManager() {
  const location = useLocation();

  useEffect(() => {
    // FIDS pages (flights display) should have kiosk-mode class
    const isFidsPage = ['/', '/departure', '/departures', '/arrival', '/arrivals'].includes(location.pathname);

    if (isFidsPage) {
      document.body.classList.add('kiosk-mode');
    } else {
      document.body.classList.remove('kiosk-mode');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('kiosk-mode');
    };
  }, [location.pathname]);

  return null;
}

// Smart default route: checks display mode and redirects departures devices
// to /departure instead of rendering arrivals. Reads from NativeFIDS (sync),
// window vars, or localStorage — no async delay.
function DefaultRoute() {
  let displayMode = null;
  try {
    if (typeof NativeFIDS !== 'undefined') {
      displayMode = NativeFIDS.getDisplayMode(); // eslint-disable-line no-undef
    }
  } catch (e) { /* not on Android */ }
  if (!displayMode) {
    displayMode = window.ANDROID_DISPLAY_MODE || localStorage.getItem('fids_display_mode');
  }

  if (displayMode === 'departures') {
    return <Navigate to="/departure" replace />;
  }

  return (
    <ArrivalProvider>
      <DepartureProvider>
        <Arrival />
      </DepartureProvider>
    </ArrivalProvider>
  );
}

export default function Router() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ModeRedirector>
          <KioskModeManager />
          <Routes>
            {/* Admin routes - outside flight data contexts */}
            <Route path="/login" element={< Login />} />
            <Route path="/debug" element={<DebugPage />} />
            <Route path="/test-admin" element={<AdminPage />} />
            <Route path="/admin" element={<PrivateRoute />} >
              <Route path="" element={<AdminPage />} />
            </Route>

            {/* Default route: redirect to /departure if display mode says departures,
                otherwise show arrivals (the original default) */}
            <Route path="/" element={<DefaultRoute />} />
            <Route path="/departure" element={
              <ArrivalProvider>
                <DepartureProvider>
                  <Departure />
                </DepartureProvider>
              </ArrivalProvider>
            } />
            <Route path="/departures" element={
              <ArrivalProvider>
                <DepartureProvider>
                  <Departure />
                </DepartureProvider>
              </ArrivalProvider>
            } />
            <Route path="/arrival" element={
              <ArrivalProvider>
                <DepartureProvider>
                  <Arrival />
                </DepartureProvider>
              </ArrivalProvider>
            } />
            <Route path="/arrivals" element={
              <ArrivalProvider>
                <DepartureProvider>
                  <Arrival />
                </DepartureProvider>
              </ArrivalProvider>
            } />
          </Routes>
        </ModeRedirector>
      </AuthProvider>
    </Provider>
  );
}
